import React from 'react';
import Image from 'components/image/Image';
import LanguagePopover from 'components/LanguagePopover';
import { useTenantInfo } from 'hooks/useTenantInfo';

import './index.scss';

type PageHeaderProps = {
  showLogo?: boolean;
  showLanguageSelector?: boolean;
};

const PageHeader = ({
  showLogo = true,
  showLanguageSelector = true
}: PageHeaderProps) => {
  const { tenantLogo } = useTenantInfo();

  if (!showLogo && !showLanguageSelector) {
    return null;
  }

  return (
    <header
      className={`page-header ${showLogo ? '' : 'page-header--language-only'}`.trim()}
    >
      {showLogo && (
        <a href="/" className="page-header__logo">
          {tenantLogo ? (
            <Image url={tenantLogo} width={210} height={50} />
          ) : (
            <Image name="new-rec-logos.svg" width={210} height={95} />
          )}
        </a>
      )}
      {showLanguageSelector && (
        <LanguagePopover className="page-header__language" />
      )}
    </header>
  );
};

export default PageHeader;
